import React from 'react';
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ADMIN_CONSTANTS, ADMIN, ADMIN_IMPORT, ADMIN_PORTFOLIOS, ADMIN_USER_PORTFOLIOS, ADMIN_INSTRUMENTS } from 'routes';

import { Tab } from '@material-ui/core';
import Tabs from 'components/CustomTabs/CustomTabs';
import Layout from 'components/Layout';
import CrumbRoute from 'components/CrumbRoute';

import Constants from './Constants/Constants';
import Import from './Import/Import';
import UserPortfolios from './UserPortfolios/UserPortfolios';
import Portfolios from './Portfolios/Portfolios';
import Instruments from './Instruments/Instruments';
import { ADMIN_IMPORT_FUNDS, ADMIN_IMPORT_PORTFOLIO, ADMIN_IMPORT_ORDERS } from 'api/endpoints';
import { Currency } from 'enums';
import { PortfolioType } from 'stores/workflowStores/newWorkflowPlanStore/model/interfaces';

// FIXME: ???
const AdminTab = [ADMIN_CONSTANTS] as const;

const Admin: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const handleTabChange = (_event: React.ChangeEvent<{}>, newTab?: typeof AdminTab[number]) => {
    newTab && history.push(newTab);
  };

  return (
    <Layout title={t('pageTitle_admin')} admin>
      <Tabs value={location.pathname === ADMIN ? ADMIN_CONSTANTS : location.pathname} onChange={handleTabChange}>
        <Tab value={ADMIN_CONSTANTS} label={t('admin_constants_title')} />
        <Tab value={ADMIN_IMPORT} label={t('admin_import_title')} />
        <Tab value={ADMIN_USER_PORTFOLIOS} label={t('admin_user_portfolios_title')} />
        <Tab value={ADMIN_INSTRUMENTS} label={t('admin_instruments_title')} />
        <Tab value={ADMIN_PORTFOLIOS} label={t('admin_portfolios_title')} />
      </Tabs>

      <Switch>
        <Route exact path={ADMIN} render={() => <Redirect to={ADMIN_CONSTANTS} />} />
        <CrumbRoute exact path={ADMIN_CONSTANTS} component={Constants} title={t('admin_constants_title')} />
        <CrumbRoute
          exact
          path={ADMIN_IMPORT}
          render={() => (
            <Import
              importMap={{
                fund: {
                  heading: t('admin_uploads_funds'),
                  endpoint: ADMIN_IMPORT_FUNDS,
                  entityText: t('admin_uploads_fundsEnt'),
                },
                portfolio: {
                  heading: t('admin_uploads_portfolios'),
                  endpoint: ADMIN_IMPORT_PORTFOLIO,
                  entityText: t('admin_uploads_partnersEnt'),
                  typeText: t('admin_esg'),
                  currencyText: t('general_currency'),
                  typeValues: [
                    { value: PortfolioType.STD, label: t('admin_portfolio_STD') },
                    { value: PortfolioType.ESG, label: t('admin_portfolio_ESG') },
                    { value: PortfolioType.BAS, label: t('admin_portfolio_BAS') },
                    { value: PortfolioType.CUS, label: t('admin_portfolio_CUS') },
                  ],
                  currencyValues: [
                    { value: Currency.CZK, label: Currency.CZK },
                    { value: Currency.EUR, label: Currency.EUR },
                  ],
                  hedgingText: t('admin_uploads_hedging')
                },
                orders: {
                  heading: t('admin_uploads_orders'),
                  endpoint: ADMIN_IMPORT_ORDERS,
                  entityText: t('admin_uploads_ordersEnt'),
                },

              }}
            />
          )}
          title={t('admin_import_title')}
        />
        <CrumbRoute exact path={ADMIN_USER_PORTFOLIOS} component={UserPortfolios} title={t('admin_user_portfolios_title')} />
        <CrumbRoute exact path={ADMIN_INSTRUMENTS} component={Instruments} title={t('admin_instruments_title')} />
        <CrumbRoute exact path={ADMIN_PORTFOLIOS} component={Portfolios} title={t('admin_portfolios_title')} />
      </Switch>
    </Layout>
  );
};

export default Admin;
